const testimonials = [
  { name: "Sergeant First Class David R.", location: "Fort Novosel, Daleville, AL", rating: 5, text: "PCS orders to Grafenwoehr, Germany arrived with 28 days to report. My wife's passport was expired and we had not updated our daughter's since she was a toddler. Fast Passport Center processed both passports in seven business days. We made our report date, cleared housing on time, and got settled in Germany without a single passport issue. For military families, these guys are an absolute lifeline.", service: "Family Expedited Passports" },
  { name: "Robert H.", location: "Dothan, AL", rating: 5, text: "I farm peanuts and soybeans in Houston County and got invited to a trade mission to Argentina with three weeks notice. My passport expired in 2021. Fast Passport Center turned my renewal around in five business days. The trade mission was a success — we signed two new export agreements. These guys understand that farming moves on market windows, not government calendars.", service: "Expedited Renewal" },
  { name: "Pastor Kevin &amp; Linda M.", location: "First Baptist Church, Dothan, AL", rating: 5, text: "We lead annual mission trips to Honduras. This year, a team member signed up two weeks before departure and her passport was expired. We called Fast Passport Center on a Tuesday, they reviewed her documents immediately, and she had her renewed passport the following Wednesday. She was on the plane with the rest of the team. We now recommend them to every team member before registration closes.", service: "Emergency Renewal" },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function DothanTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Dothan &amp; Wiregrass Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Fort Novosel families, agribusiness professionals, and Wiregrass mission travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic" dangerouslySetInnerHTML={{ __html: `&ldquo;${t.text}&rdquo;` }}></p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm" dangerouslySetInnerHTML={{ __html: t.name }}></p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">{t.service}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}